/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import axios from 'axios'
import Swal from 'sweetalert2'
import firebase from '../../../firebase/FirebaseConfig'

export const UserDetailModal = ({
  showMadalUserDetail,
  setShowMadalUserDetail,
  selectedUser,
  setSelectedUser,
  handleDeleteUser,
}) => {
  const closeModal = () => {
    setShowMadalUserDetail(false)
    setSelectedUser(null)
  }

  return (
    <>
      <Modal show={showMadalUserDetail} onHide={() => closeModal()} size='lg'>
        <Modal.Header>
          <Modal.Title>
            <h3 className='fw-600'>User detail</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='p-2'>
            <div className='row'>
              <div className='col-12 mb-5'>
                <label className='form-label'>Email</label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  disabled={true}
                  value={selectedUser?.email}
                />
              </div>
              <div className='col-12 mb-5'>
                <label className='form-label'>Name</label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  disabled={true}
                  value={selectedUser?.firstName + ' ' + selectedUser?.lastName}
                />
              </div>

              <div className='col-12 mb-5'>
                <label className='form-label'>Role</label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  disabled={true}
                  value={selectedUser?.role}
                />
              </div>

              <div className='col-12 mb-5'>
                <label className='form-label'>User Id Malin1</label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  disabled={true}
                  value={selectedUser?.userIdMalin1}
                />
              </div>

              <div className='col-12 mb-10'>
                <label className='form-label'>User Id mConnect</label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  value={selectedUser?.userId}
                  disabled={true}
                />
              </div>

              <div className='col-12'>
                <div
                  className='btn btn-danger w-100'
                  onClick={() => handleDeleteUser(selectedUser?.userId)}
                >
                  Delete User
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-secondary' onClick={() => closeModal()}>
            ปิด
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
